import React from 'react';
import { ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-red-50 border-y border-red-100 py-12 px-4" data-id="element-328">
      <div className="max-w-4xl mx-auto text-center" data-id="element-329">
        <ClockIcon className="w-16 h-16 text-red-600 mx-auto mb-4 animate-pulse" data-id="element-330" />
        <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-6" data-id="element-331">
          Attenzione: l'offerta sta per scadere
        </h2>
        <CountdownTimer data-id="element-332" />
      </div>
    </section>;
}